import { render, staticRenderFns } from "./TableLPC.vue?vue&type=template&id=75dfab98&"
import script from "./TableLPC.vue?vue&type=script&lang=js&"
export * from "./TableLPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports